export enum LayersCopiedStatus {
    Completed = "Completed",
    Processing = "Processing",
    Failed = "Failed",
    ValidationError = "ValidationError"
}